export const brandingLogoMaxBytes = 512 * 1024;

export function isSupportedBrandingLogo(file: Pick<File, 'type' | 'size'>) {
  return (
    ['image/png', 'image/jpeg', 'image/svg+xml'].includes(file.type) &&
    file.size > 0 &&
    file.size <= brandingLogoMaxBytes
  );
}
